document.addEventListener('DOMContentLoaded', function () {
  const swatchWrappers = document.querySelectorAll('.product-option-swatch-wrapper');
  const colorDisplay = document.getElementById('selected-color');

  // Find main product image (adapt to your theme if needed)
  function getMainImageElement() {
    return document.querySelector(
      '.product__media img, .product-gallery__image, .product__main-img, .media img, .product-main-image img'
    );
  }

  swatchWrappers.forEach(wrapper => {
    wrapper.addEventListener('click', function () {
      // Deselect all swatches
      swatchWrappers.forEach(w => {
        const swatch = w.querySelector('.product-option-swatch');
        if (swatch) swatch.classList.remove('selected');
      });

     // Highlight selected swatch
      const swatch = wrapper.querySelector('.product-option-swatch');
      if (swatch) swatch.classList.add('selected');

      // Update main image
      const newImage = wrapper.getAttribute('data-image');
      const mainImage = getMainImageElement();
      if (mainImage && newImage) {
        mainImage.src = newImage;
        mainImage.srcset = ''; // Reset srcset to prevent override from lazyload
      }

      // Show selected color name
      const colorName = wrapper.getAttribute('data-color');
      if (colorDisplay) {
        colorDisplay.textContent = `Selected Color: ${colorName}`;
      }
    });
  });
});